import { useNavigate } from 'react-router-dom'

import ArrowDown from '../../../assets/images/icons/arrow-down.svg?react'
import ArrowUp from '../../../assets/images/icons/arrow-up.svg?react'
import FeaturedIcon from '../../../assets/images/icons/featured-icon.svg?react'
import type { PriceChanges } from '../../../store/types/dashboard'
import Mixpanel from '../../../utils/mixpanel/Mixpanel'

type PriceChangesProps = {
  changes: PriceChanges | undefined
  view?: string
}

function DashboardPriceChanges({
  changes,
  view,
}: PriceChangesProps): JSX.Element {
  const navigate = useNavigate()

  const sendEvent = (event: string): void => {
    Mixpanel.track(event, {
      page: view,
      section: 'Price Changes Card',
    })
  }

  return (
    <div className="flex container mx-auto px-4 py-5 lg:p-6 flex-col justify-between sm:col-span-3 self-start border border-solid border-gray-200 rounded-lg shadow ">
      <div className="flex flex-row sm:flex-col xl:flex-row items-center gap-2 whitespace-nowrap">
        <div className="flex">
          <FeaturedIcon />
        </div>
        <span className="font-medium text-lg text-gray-900">Price Changes</span>
      </div>
      <div className="flex flex-col whitespace-nowrap mt-8">
        <div className="flex flex-row justify-between pb-3 ">
          <button
            onClick={(): void => {
              sendEvent('Increased Clicked')
              navigate(
                '/products?page=1&limit=10&orderBy=name&orderDirection=asc&competitor_change=1',
              )
            }}
            className="flex flex-row items-center"
          >
            <ArrowUp />
            <span className="font-medium text-base text-green-100 pl-2">
              Increased
            </span>
          </button>
          <button
            onClick={(): void => {
              sendEvent('Increased Clicked')
              navigate(
                '/products?page=1&limit=10&orderBy=name&orderDirection=asc&competitor_change=1',
              )
            }}
          >
            <span className="font-normal text-base text-gray-500">
              {changes?.increased} Products
            </span>
          </button>
        </div>

        <div className="flex flex-row justify-between pb-3 ">
          <button
            onClick={(): void => {
              sendEvent('Decreased Clicked')
              navigate(
                '/products?page=1&limit=10&orderBy=name&orderDirection=asc&competitor_change=0',
              )
            }}
            className="flex flex-row items-center"
          >
            <ArrowDown />
            <span className="font-medium text-base text-red-100 pl-2">
              Decreased
            </span>
          </button>
          <button
            onClick={(): void => {
              sendEvent('Decreased Clicked')
              navigate(
                '/products?page=1&limit=10&orderBy=name&orderDirection=asc&competitor_change=0',
              )
            }}
          >
            <span className="font-normal text-base text-gray-500 ">
              {changes?.decreased} Products
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default DashboardPriceChanges
